export enum DocumentCategory {
    ProofOfId = <any>'ProofOfId',
    ProofOfAddress = <any>'ProofOfAddress',
    Photo = <any>'Photo',
    Nach = <any>'Nach',
    Other = <any>'Other',
}

export enum Lables {
    ProofOfId,
    ProofOfAddress,
    Photo,
    Nach,
    Other
}

export enum ProofOfId {
    PanCard = <any>'PanCard',
    DrivingLicense = <any>'DrivingLicense',
    FrontOfAadhaar = <any>'FrontOfAadhaar',
    Passport = <any>'Passport',
    VoterId = <any>'VoterId'
}

export enum ProofOfAddress {
    DrivingLicense = <any>'DrivingLicense',
    BackOfAadhaar = <any>'BackOfAadhaar',
    Passport = <any>'Passport',
    PropertyRegistrationCertificate = <any>'PropertyRegistrationCertificate',
    VoterId = <any>'VoterId',
    UtilityBill = <any>'UtilityBill',
    RationCard = <any>'RationCard',
    BankStatement = <any>'BankStatement'
}

export enum KycLabels {
    DrivingLicense = <any>'DrivingLicense',
    Aadhaar = <any>'Aadhaar',
    Passport = <any>'Passport',
    VoterId = <any>'VoterId',
    Photo = <any>'Photo'
}

export enum Photo {
    Photo = <any>'Photo'
}

export enum Other {
    Other
}

export enum Nach {
    UnsignedNach,
    SignedNach,
}

export const DocumentParams = {
    imageFileFormats: ['image/jpeg', 'image/jpg', 'image/png'],
    pdfFileFormat: ['application/pdf'],
    pdfAndImageFileFormats: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
    fileSize15Mb: 15728640,
    fileSize10Kb: 10240,
    fileSize5Mb: 5242880,
};

export enum AdditionalDocumentLables {
    // SignedNach = <any>'SignedNach',
    PanCard = <any>'PanCard',
    DrivingLicense = <any>'DrivingLicense',
    FrontOfAadhaar = <any>'FrontOfAadhaar',
    BackOfAadhaar = <any>'BackOfAadhaar',
    Passport = <any>'Passport',
    VoterId = <any>'VoterId',
    PropertyRegistrationCertificate = <any>'PropertyRegistrationCertificate',
    CompanyRegistrationCertificate = <any>'CompanyRegistrationCertificate',
    UtilityBill = <any>'UtilityBill',
    RationCard = <any>'RationCard',
    BankStatement = <any>'BankStatement'
}

export enum kycFlow {
    DigitalKyc = 'DigitalKyc',
    OfflineKyc = 'OfflineKyc',
    IPVKyc = 'IPVKyc'
}

export enum kycFlowStatus {
    Initiated = 'Initiated',
    Submitted = 'Submitted',
    Verified = 'Verified',
    Pending = 'Pending'
}

export enum IPVMode {
    Video = 'Video',
    InPerson = 'InPerson'
}

export enum kycStatus {
    Initiated = 'Initiated',
    Pending = 'Pending',
    Verified = 'Verified',
    Rejected = 'Rejected'
}

export enum submitPageContentVerified {
    submitHeader = 'KYC VERIFICATION SUCCESSFUL !',
    submitPageSubHeader = '',
    logoSrc = '../../../assets/images/green-double-tick.png'
}

export enum submitPageContentPending {
    submitHeader = 'KYC VERIFICATION PENDING',
    submitPageSubHeader = 'Your KYC details are submitted. It may take upto 24 hours to verify your information',
    logoSrc = '../../../assets/images/green-single-tick.png'
}

export enum submitPageContentDocumentsPending {
    submitHeader = 'Document Review Pending',
    submitPageSubHeader = '',
    logoSrc = '../../../assets/images/green-single-tick.png'
}

export enum okycValidationStep {
    Fetching = 'Fetching',
    Validating = 'Validating',
    Verified = 'Verified',
    Rejected = 'Rejected',
    InReview = 'InReview'
}

export enum ValidationHeader {
    progress = <any>['KYC verification is in progress', 'Once verified you can proceed to next step.'],
    verified = <any>['KYC verification is successful', 'You can proceed to the next step.']
}
